import { render, staticRenderFns } from "./WhistleblowerButton.vue?vue&type=template&id=4bfe0c0c"
import script from "./WhistleblowerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WhistleblowerButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports